let site = "currentSite"
let siteName = "intro"
import { getSiteId } from "./animation.js";

getSiteId(site, siteName);